/* eslint-disable import/no-cycle */
import Vue from 'vue';
import VueRouter from 'vue-router';
import Role from '@/enums/userRoles';
import store from '@/store';

// import store from '@/store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "Home" */ '../views/Home.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/google/search',
    name: 'googleSearch',
    component: () => import(/* webpackChunkName: "FavesByCountryName." */ '../views/GoogleSearchPage.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/terms',
    name: 'termsConditions',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "TermConditions" */ '../views/Terms.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/faves-by-country',
    name: 'favesByCountry',
    component: () => import(/* webpackChunkName: "FavesByCountry" */ '../views/Categories/FavesByCountry.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/faves-by-country/:countryName',
    name: 'favesByCountryName',
    component: () => import(/* webpackChunkName: "FavesByCountryName." */ '../views/Categories/FavesByCountryName.vue'),
    meta: { requiresAuth: false },
    props: true,
  },
  {
    path: '/privacy',
    name: 'privacy',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "Privacy" */ '../views/Privacy.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/aboutUs',
    name: 'aboutUs',
    component: () => import(/* webpackChunkName: "Home" */ '../views/AboutUs.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/press',
    name: 'press',
    component: () => import(/* webpackChunkName: "Press" */ '../views/Press.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import(/* webpackChunkName: "Contact" */ '../views/Contact.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/faq',
    name: 'faq',
    component: () => import(/* webpackChunkName: "Contact" */ '../views/Faq.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/categories/weekly-faves/:year',
    name: 'weeklyFaves',
    component: () => import(/* webpackChunkName: "WeeklyFaves" */ '../views/Categories/WeeklyPage.vue'),
    props(route) { // <-- props as a Function
      return {
        default: true,
        categoryName: 'weeklyFaves',
        year: route.params.year,
      };
    },
    meta: { requiresAuth: false },
  },
  {
    path: '/categories',
    name: 'categories',
    redirect: { name: 'weeklyFaves' },
    component: () => import(/* webpackChunkName: "User/Main" */ '../views/User/Main.vue'),
    children: [
      {
        path: 'weekly-games/:year',
        name: 'weeklyGames',
        component: () => import(/* webpackChunkName: "WeeklyGames" */ '../views/Categories/GamesPage.vue'),
        props(route) { // <-- props as a Function
          return {
            default: true,
            categoryName: 'weeklyGames',
            year: route.params.year,
          };
        },
        meta: { requiresAuth: false },
      },
      {
        path: ':categoryName',
        name: 'TYPE_CATEGORY',
        component: () => import(/* webpackChunkName: "categories" */ '../views/Categories/CategoryPage.vue'),
        props(route) { // <-- props as a Function
          return {
            default: true,
            categoryName: route.params.categoryName,
          };
        },
        meta: { requiresAuth: false },
      },
    ],
  },
  {
    // Where an empty tile in a category row leads. Public: the people worth
    // reaching are the ones already reading the page, and asking them to have
    // an account before they can find out the terms would lose most of them.
    path: '/advertise',
    name: 'advertise',
    component: () => import(/* webpackChunkName: "Advertise" */ '../views/Advertise.vue'),
    meta: { requiresAuth: false },
  },
  {
    // Browsable archive of everything ever featured, built from
    // directory_entries (see amf:directory:build in the API).
    path: '/directory',
    name: 'directory',
    component: () => import(/* webpackChunkName: "Directory" */ '../views/Directory.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/top-faves/:year',
    name: 'TYPE_TOP_FAVES',
    component: () => import(/* webpackChunkName: "TopFaves" */ '../views/Categories/TopFaves.vue'),
    props: true,
    meta: { requiresAuth: false },
  },
  {
    path: '/top-games/:year',
    name: 'TYPE_TOP_GAMES',
    component: () => import(/* webpackChunkName: "TopGames" */ '../views/Categories/TopGames.vue'),
    props: true,
    meta: { requiresAuth: false },
  },
  {
    path: '/top-blogs/:year',
    name: 'TYPE_BLOGS',
    component: () => import(/* webpackChunkName: "TopBlogs" */ '../views/Categories/TopBlogs.vue'),
    props: true,
    meta: { requiresAuth: false },
  },
  {
    path: '/user',
    name: 'user',
    component: () => import(/* webpackChunkName: "User/Main" */ '../views/User/Main.vue'),
    redirect: { name: 'account' },
    children: [
      {
        path: 'step1',
        name: 'step1Login',
        component: () => import(/* webpackChunkName: "User/Auth/ForgotPassword" */ '../views/FirstLogin/SelectFavorites.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'step2',
        name: 'step2Login',
        component: () => import(/* webpackChunkName: "User/Auth/ForgotPassword" */ '../views/FirstLogin/AddChromeExtesionStep.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'faveItButton',
        name: 'faveItButton',
        component: () => import(/* webpackChunkName: "FaveItButton" */ '../components/common/user/FaveItButton.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'bookmarklet',
        name: 'bookmarklet',
        component: () => import(/* webpackChunkName: "FaveItButton" */ '../components/common/user/Bookmarklet.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: '/user-settings',
        name: 'userDashboard',
        meta: { requiresAuth: true },
        component: () => import(/* webpackChunkName: "User/Dashboard" */ '../views/User/Dashboard.vue'),
        children: [
          {
            path: 'account',
            name: 'account',
            component: () => import(/* webpackChunkName: "Account" */ '../components/common/user/Account.vue'),
            meta: { requiresAuth: true },
          },
          {
            path: 'billing',
            name: 'billing',
            component: () => import('../components/common/user/Billing.vue'),
            meta: { requiresAuth: true },
          },
          {
            path: 'purchase',
            name: 'purchase',
            component: () => import('../components/common/user/Payment.vue'),
            meta: { requiresAuth: true },
          },
          {
            path: 'thanks',
            name: 'thanks',
            component: () => import('../components/common/user/ThankScreen.vue'),
            meta: { requiresAuth: true },
          },
          {
            path: 'export',
            name: 'export',
            component: () => import(/* webpackChunkName: "Export" */ '../components/common/user/Export.vue'),
            meta: { requiresAuth: true },
          },
        ],
      },
      {
        path: '/:provider/callback',
        name: 'userSocialLogin',
        props: true,
        component: () => import(/* webpackChunkName: "User/Auth/SocialLogin" */ '../views/User/Auth/SocialLogin.vue'),
        meta: { requiresAuth: false },
      },
      {
        path: 'login',
        name: 'userLogin',
        component: () => import(/* webpackChunkName: "User/Auth/Login" */ '../views/User/Auth/Login.vue'),
        meta: { requiresAuth: false },
      },
      {
        path: 'register',
        name: 'userRegister',
        component: () => import(/* webpackChunkName: "User/Auth/Register" */ '../views/User/Auth/Register.vue'),
        meta: { requiresAuth: false },
      },
      {
        path: 'forgot-password',
        name: 'userForgotPassword',
        component: () => import(/* webpackChunkName: "User/Auth/ForgotPassword" */ '../views/User/Auth/ForgotPassword.vue'),
        meta: { requiresAuth: false },
      },
      {
        path: 'reset-password/:token/:username',
        props: true,
        name: 'userResetPassword',
        component: () => import(/* webpackChunkName: "User/Auth/ResetPassword" */ '../views/User/Auth/ResetPassword.vue'),
        meta: { requiresAuth: false },
      },
      {
        path: 'confirm-email/:email/',
        name: 'ConfirmAccount',
        component: () => import(/* webpackChunkName: "User/Auth/ConfirmAccountView" */ '../views/User/Auth/ConfirmAccountView.vue'),
        meta: { requiresAuth: false },
      },
      {
        path: 'confirm-account/:token/',
        props: true,
        name: 'userConfirmAccount',
        component: () => import(/* webpackChunkName: "User/Auth/ResetPassword" */ '../views/User/Auth/ConfirmAccount.vue'),
        meta: { requiresAuth: false },
      },
    ],
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import(/* webpackChunkName: "Admin/Main" */ '../views/Admin/Main.vue'),
    // A logo reviewer cannot open the dashboard, so sending them there would
    // bounce them straight out to the homepage on visiting /admin.
    redirect: () => (store.getters.user && store.getters.user.role === Role.logoReviewer
      ? { name: 'adminLogoReview' }
      : { name: 'adminDashboard' }),
    children: [
      {
        path: 'dashboard',
        name: 'adminDashboard',
        meta: {
          authorize: [Role.admin],
          isAdmin: true,
          requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "Admin/Dashboard" */ '../views/Admin/Dashboard.vue'),
      },
      {
        path: 'users',
        name: 'adminUsersListing',
        meta: {
          authorize: [Role.admin],
          isAdmin: true,
          requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "Admin/Users/Users" */ '../views/Admin/Users/Users.vue'),
      },
      {
        path: 'users/:id?',
        name: 'adminUserSingle',
        props: true,
        meta: {
          authorize: [Role.admin],
          isAdmin: true,
          requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "Admin/FavPages/FavPage" */ '../views/Admin/Users/User.vue'),
      },
      {
        path: 'sites',
        name: 'adminSitesListing',
        meta: {
          authorize: [Role.admin],
          isAdmin: true,
          requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "Admin/Users/Users" */ '../views/Admin/Sites/Sites.vue'),
      },
      {
        path: 'unlistedSites',
        name: 'adminUnlistedSitesListing',
        meta: {
          authorize: [Role.admin],
          isAdmin: true,
          requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "Admin/Users/Users" */ '../views/Admin/UnlistedSites/UnlistedSites.vue'),
      },
      {
        path: 'favline-logos',
        name: 'adminFavlineLogoReview',
        meta: {
          authorize: [Role.admin],
          isAdmin: true,
          requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "Admin/LogoReview" */ '../views/Admin/LogoReview/FavlineLogoReview.vue'),
      },
      {
        path: 'logo-review',
        name: 'adminLogoReview',
        meta: {
          authorize: [Role.admin, Role.logoReviewer],
          isAdmin: true,
          requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "Admin/LogoReview" */ '../views/Admin/LogoReview/LogoReview.vue'),
      },
      {
        path: 'uploadedWebsites',
        name: 'adminUploadedWebsitesListing',
        meta: {
          authorize: [Role.admin],
          isAdmin: true,
          requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "Admin/Users/Users" */ '../views/Admin/UploadedWebsites/Websites.vue'),
      },
      {
        path: 'failedUuploadedWebsites',
        name: 'adminFailedUploadedWebsitesListing',
        meta: {
          authorize: [Role.admin],
          isAdmin: true,
          requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "Admin/Users/Users" */ '../views/Admin/UploadedWebsites/Websites.vue'),
      },
      {
        path: 'sponsorship',
        name: 'adminSponsorship',
        meta: {
          authorize: [Role.admin],
          isAdmin: true,
          requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "Admin/Sponsorship" */ '../views/Admin/Sponsorship/Sponsorship.vue'),
      },
      {
        path: 'engagement',
        name: 'adminEngagement',
        meta: {
          authorize: [Role.admin],
          isAdmin: true,
          requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "Admin/Engagement" */ '../views/Admin/Engagement/Engagement.vue'),
      },
      {
        path: 'logs',
        name: 'adminLogs',
        meta: {
          authorize: [Role.admin],
          isAdmin: true,
          requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "Admin/Logs" */ '../views/Admin/Logs/Logs.vue'),
      },
      {
        path: 'mostPopularSites',
        name: 'mostPopularSites',
        meta: {
          authorize: [Role.admin],
          isAdmin: true,
          requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "Admin/Users/Users" */ '../views/Admin/Sites/MostPopularSites.vue'),
      },
      {
        path: 'mostPopularSite/:id',
        name: 'adminMostPopularSiteSingle',
        props: true,
        meta: {
          authorize: [Role.admin],
          isAdmin: true,
          requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "Admin/FavPages/FavPage" */ '../views/Admin/Sites/MostPopularSite.vue'),
      },
      {
        path: 'sites/:id?',
        name: 'adminSiteSingle',
        props: true,
        meta: {
          authorize: [Role.admin],
          isAdmin: true,
          requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "Admin/FavPages/FavPage" */ '../views/Admin/Sites/Site.vue'),
      },
      {
        path: 'unlistedSites/:id?',
        name: 'adminUnlistedSiteSingle',
        props: true,
        meta: {
          authorize: [Role.admin],
          isAdmin: true,
          requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "Admin/FavPages/FavPage" */ '../views/Admin/UnlistedSites/UnlistedSite.vue'),
      },
      {
        path: 'uploadedWebsites/:id?',
        name: 'adminUploadedWebsiteSingle',
        meta: {
          authorize: [Role.admin],
          isAdmin: true,
          requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "Admin/Users/Users" */ '../views/Admin/UploadedWebsites/WebsitePage.vue'),
      },
      {
        path: 'favPages',
        name: 'adminFavPagesListing',
        meta: {
          authorize: [Role.admin],
          isAdmin: true,
          requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "Admin/FavPages/FavPages" */ '../views/Admin/FavPages/FavPages.vue'),
      },
      {
        path: 'favPages/:id',
        name: 'adminFavPageSingle',
        props: true,
        meta: {
          authorize: [Role.admin],
          isAdmin: true,
          requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "Admin/FavPages/FavPage" */ '../views/Admin/FavPages/FavPage.vue'),
      },
      {
        path: 'settings',
        name: 'adminSettings',
        meta: {
          authorize: [Role.admin],
          isAdmin: true,
          requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "Admin/FavPages/FavPages" */ '../views/Admin/Settings/Settings.vue'),
      },
      {
        path: 'settings/:id',
        name: 'adminSettingPageSingle',
        meta: {
          authorize: [Role.admin],
          isAdmin: true,
          requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "Admin/FavPages/FavPages" */ '../views/Admin/Settings/Setting.vue'),
      },
      {
        path: 'editor-tokens',
        name: 'adminEditorTokens',
        meta: {
          authorize: [Role.admin],
          isAdmin: true,
          requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "Admin/FavPages/FavPages" */ '../views/Admin/EditorTokens/EditorTokens.vue'),
      },
      {
        path: 'editor-tokens/:id',
        name: 'adminEditorTokenPageSingle',
        meta: {
          authorize: [Role.admin],
          isAdmin: true,
          requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "Admin/FavPages/FavPages" */ '../views/Admin/EditorTokens/EditorToken.vue'),
      },
      {
        path: 'email',
        name: 'email',
        meta: {
          authorize: [Role.admin],
          isAdmin: true,
          requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "Admin/FavPages/FavPages" */ '../views/Admin/Email.vue'),
      },
      {
        path: 'banner-settings',
        name: 'banner-settings',
        meta: {
          authorize: [Role.admin],
          isAdmin: true,
          requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "Admin/FavPages/FavPages" */ '../views/Admin/BannerSettings.vue'),
      },
      {
        path: 'subscription-codes',
        name: 'SubscriptionCodesListing',
        meta: {
          authorize: [Role.admin],
          isAdmin: true,
          requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "Admin/Users/Users" */ '../views/Admin/SubscriptionCodes/SubscriptionCodes.vue'),
      },
    ],
  },
  {
    path: '/:username',
    name: 'myFaves',
    props: true,
    component: () => import(/* webpackChunkName: "FaveItButton" */ '../components/common/user/MyFaves.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '*',
    name: 'not-found',
    component: () => import(/* webpackChunkName: "about" */ '../views/NotFound.vue'),
    meta: { requiresAuth: false },
  },

  // // a param can be made optional by adding "?"
  // { path: '/optional-params/:foo?' },
  // // a param can be followed by a regex pattern in parens
  // // this route will only be matched if :id is all numbers
  // { path: '/params-with-regex/:id(\\d+)' },
  // // asterisk can match anything
  // { path: '/asterisk/*' },
  // // make part of the path optional by wrapping with parens and add "?"
  // { path: '/optional-group/(foo/)?bar' }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

// router.beforeEach((to, from, next) => {
// console.log('====================');
// console.log('router.BeforeEach');
// console.log('FROM :: ', from);
// console.log('TO :: ', to);
// console.log('NEXT :: ', next);
// console.log('====================');

// TODO disable this to be able to navigate through pages
// TODO enable this to check for permissions
// const { authorize } = to.meta;
// const authenticated = store.getters.isAuthenticated;
// const currentUser = store.getters.user;
//
// if (authorize) {
//   if (!authenticated && (authorize.includes(Role.admin))) {
//     return next({ path: '/admin/login', query: { nextUrl: to.fullPath } });
//   }
//   if (!authenticated && authorize.includes(Role.user)) {
//     return next({ path: '/user/login', query: { nextUrl: to.fullPath } });
//   }
//   if (currentUser && authenticated && authorize.length && !authorize.includes(currentUser.role)) {
//     // role not authorised so redirect to home page - should logoff nad login with the good user before trying again
//     return next({ path: '/' });
//   }
// }

// DYNAMIC ROUTES
// https://github.com/vuejs/vue-router/blob/dev/examples/route-props/app.js

// Sub-domain routing
// console.log(window.location.host);
//
// return next();
// });
//
// router.afterEach((to, from) => {
//   console.log('====================');
//   console.log('router.BeforeEach');
//   console.log('FROM :: ', from);
//   console.log('TO :: ', to);
//   console.log('isAuthenticated', store.getters.isAuthenticated);
//   console.log('====================');
// });
// Where a locked account is still allowed to go. Everything else sends it back
// to plan selection: the account exists and can sign in, but choosing a plan is
// the only thing it can do until it has one.
// 'thanks' matters: it is where PayPal returns to after a successful payment,
// and the cached user record still says locked at that moment. Without it the
// account would be bounced back to billing seconds after paying.
// 'advertise' is here because buying a slot and subscribing are different
// products. A locked account bounced to plan selection on its way to buy
// advertising would be sent to pay for the wrong thing, and we would lose the
// sale to a guard that was never meant to be pointed at customers.
const PAYWALL_ALLOWED_ROUTES = ['purchase', 'thanks', 'billing', 'account', 'userLogin', 'termsConditions', 'privacy', 'contact', 'advertise'];

function isLocked() {
  const { user } = store.getters;
  return !!(user && user.locked_by_paywall);
}

router.beforeEach((to, from, next) => {
  // Only signed-in areas are redirected. AllMyFaves is a public directory
  // first - the homepage, the categories and /directory are the reason people
  // come, and a locked account is still a reader. What it cannot do is create
  // tabs or have a public page, and the API enforces both of those directly.
  //
  // Billing rather than purchase: purchase drops you straight into a promo-code
  // box and a PayPal button with no indication of what you are buying.
  if (to.meta.requiresAuth
    && store.getters.isAuthenticated
    && isLocked()
    && !PAYWALL_ALLOWED_ROUTES.includes(to.name)) {
    next({ name: 'billing' });
    return;
  }

  if (to.meta.requiresAuth) {
    if (store.getters.isAuthenticated) {
      if (to.meta.isAdmin) {
        // Honour each route's own authorize list rather than assuming every
        // /admin route means "admin". Narrower roles exist now - a logo
        // reviewer reaches the review queue and nothing else - and a route
        // without a list stays admin-only, which is the safe default.
        const allowed = to.meta.authorize && to.meta.authorize.length
          ? to.meta.authorize
          : [Role.admin];

        if (allowed.includes(store.getters.user.role)) {
          next();
        } else {
          next({ name: 'home' });
        }
      } else {
        next();
      }
    } else {
      // Remembered so signing in returns here (LOGIN_SUCCESS).
      next({ name: 'userLogin', query: { redirect: to.fullPath } });
    }
  } else if (to.name === 'userLogin' || to.name === 'userRegister') {
    if (store.getters.isAuthenticated) {
      next({ name: 'home' });
    } else {
      next();
    }
  } else {
    next();
  }
});
export default router;
